import AppState from '../state';
import { getMainDomain } from '../../utils/get-artist-site-url';

export const artistSiteUrl = (state: AppState, forceFresh = false): string => {
  return `https://${
    state.subdomain.currentSubdomain?.subdomain || state.artist.active?.shortId
  }.${getMainDomain()}?forceFresh=${forceFresh}&v=${new Date().getTime()}`;
};
